import styled from "styled-components";
import { device } from "./device";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
const HeaderBlock = styled.div`
  height: 80px;
  display: flex;
  align-items: center;
  background-color: white;
  padding-left: 50px;
  margin-bottom: 80px;
  @media ${device.mobile} {
    padding-left: 20px;
    height: 60px;
    margin-bottom: 50px;
  }
`;
const Logo = styled.img`
  height: 40px;
  width: 120px;

  @media ${device.mobile} {
    height: 30px;
    width: 90px;
  }
`;

const SvgContainer = styled.div`
  fill: #f3f4f6;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -1;

  @media ${device.mobile} {
    top: 40px;
  }
`;

const Title = styled.div`
  margin-left: 10px;
  color: #344766;
  font-size: 18px;
  font-weight: 400;
`;
const Header = () => {
  const location = useLocation();

  const [titleValue, setTitleValue] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    if (location.pathname.includes("/hivex_issuer_customersupport/PP")) {
      setTitleValue("header");
    } else {
      setTitleValue("");
    }
  }, [location]);

  return (
    <div>
      <SvgContainer>
        <svg className="intersect" viewBox="0 0 1441 271">
          <g
            id="intersect"
            transform="translate(0.178955, 0.820312)"
            fillRule="nonzero"
          >
            <path
              d="M0,177.850479 L0,0 L1440.00104,0 L1440.00104,177.850479 C1268.57105,239.085479 1021.55925,277.43899 731.888245,277.43899 C442.215245,277.43899 171.433045,239.085479 0,177.850479 Z"
              id="Path"
            ></path>
          </g>
        </svg>
      </SvgContainer>
      <HeaderBlock>
        <Logo src={`${process.env.PUBLIC_URL}/logo.png`} />
        {titleValue && <Title>{t(titleValue)}</Title>}
      </HeaderBlock>
    </div>
  );
};
export default Header;
